import { method } from './api';

export function currentUser() {
  return method("auth.profile");
}


export function login(data) {
  return method(
    'auth.login',
    data
  );
}
export function logOut() {
  return method(
    'auth.logout',
  );
}